// loader.interceptors.ts
import { Injectable } from '@angular/core';
import {
    HttpErrorResponse,
    HttpResponse,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LayoutService } from '../services/layout.service';
 
@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
    private requests: HttpRequest<any>[] = [];
 
    constructor(private loaderService: LayoutService) { }
 
    removeRequest(req: HttpRequest<any>) {
        const i = this.requests.indexOf(req);
        if (i >= 0) {
            this.requests.splice(i, 1);
        }
        this.loaderService.isLoading.next(this.requests.length > 0);
    }
 
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if(req.url.search("Users/GetUserDetails") === -1 && req.url.search("GetAlertNotificationByUser") === -1 && req.url.search("Notification/GetMessages") === -1 && req.url.search("HandshakeonSignIn") === -1 && req.url.search("CognitiveSearch/Autocomplete") === -1 && req.url.search("CognitiveSearch/SuggestwithData") === -1 && req.url.search("/CheckPlanNameExists") === -1 && req.url.search("Users/UserLookUpByEmail") === -1 && req.url.search("Account/HartmannLogInAuthFacilitySubscription") === -1) {
            this.requests.push(req);
            this.loaderService.isLoading.next(true);
        }
        return Observable.create(observer => {
            const subscription = next.handle(req)
                .subscribe(
                    event => {
                        if (event instanceof HttpResponse) {
                            this.removeRequest(req);
                            observer.next(event);
                        }
                    },
                    err => {
                       
                        this.removeRequest(req);
                        observer.error(err);
                    },
                    () => {
                        this.removeRequest(req);
                        observer.complete();
                    });
            // remove request from queue when cancelled
            return () => {
                this.removeRequest(req);
                subscription.unsubscribe();
            };
        });
    }
}